// SPDX-License-Identifier: AGPL-3.0-or-later

import type {VoiceEngineStats} from '@app/features/voice/engine/native_voice_engine/VoiceEngine';
import {makeAutoObservable, runInAction} from 'mobx';

class NativeVoiceStatsStore {
	private _stats: VoiceEngineStats | null = null;

	constructor() {
		makeAutoObservable(this, {}, {autoBind: true});
	}

	get stats(): VoiceEngineStats | null {
		return this._stats;
	}

	setStats(stats: VoiceEngineStats | null): void {
		runInAction(() => {
			this._stats =
				stats && stats.droppedVideoFrameCallbacks == null && this._stats?.droppedVideoFrameCallbacks != null
					? {...stats, droppedVideoFrameCallbacks: this._stats.droppedVideoFrameCallbacks}
					: stats;
		});
	}

	clear(): void {
		if (this._stats == null) return;
		runInAction(() => {
			this._stats = null;
		});
	}
}

const instance = new NativeVoiceStatsStore();

export default instance;
export {NativeVoiceStatsStore};
